module.exports = __webpack_public_path__ + "4018ae9be8d2707b4e8b21396093f179.pdf";